var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60691",
    "data-name": "Group 60691",
    transform: "translate(-34 -11278)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1309",
    "data-name": "Rectangle 1309",
    width: 24,
    height: 24,
    transform: "translate(34 11278)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1918186aafe219e6009aef9f0ce2a92d",
    "data-name": "1918186aafe219e6009aef9f0ce2a92d",
    transform: "translate(32.641 11276.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24319",
    "data-name": "Path 24319",
    d: "M22.07,2H11.47a1.9,1.9,0,0,0-1.9,1.894v9.468H8.057a1.5,1.5,0,0,0-1.435,1.979c-.025,0-.049-.012-.076-.014a.891.891,0,0,0-.724.317.956.956,0,0,0-.189.836l.25,1.093a6.612,6.612,0,0,1-1.571-3.14l-.172-.871A1.177,1.177,0,0,0,3.068,12.6a1.012,1.012,0,0,0-.8.334,1.089,1.089,0,0,0-.254.9l.266,1.7a10.2,10.2,0,0,0,3.055,5.788v.375H5.028a.379.379,0,0,0-.379.379v2.272a.379.379,0,0,0,.379.379H9.572a.379.379,0,0,0,.379-.379V22.072a.379.379,0,0,0-.379-.379H9.564L9.528,20.2v0A4.514,4.514,0,0,0,7.94,16.977l-.334-.663a1.487,1.487,0,0,0,.451.076H18.283a1.867,1.867,0,0,0,.916-.247l-.42.833A4.514,4.514,0,0,0,17.192,20.2v.006l-.036,1.488h-.009a.379.379,0,0,0-.379.379v2.272a.379.379,0,0,0,.379.379h4.545a.379.379,0,0,0,.379-.379V22.072a.379.379,0,0,0-.379-.379h-.308v-.374a10.2,10.2,0,0,0,3.055-5.788l.267-1.688a1.089,1.089,0,0,0-.254-.9,1.013,1.013,0,0,0-.8-.335,1.177,1.177,0,0,0-1.073.955l-.172.871a6.612,6.612,0,0,1-1.571,3.14l.25-1.093a.956.956,0,0,0-.189-.836.876.876,0,0,0-.724-.317.942.942,0,0,0-.215.041,1.869,1.869,0,0,0,.22-.868V5.03h4.166a.379.379,0,0,0,.379-.379A2.654,2.654,0,0,0,22.07,2ZM9.194,23.965H5.406V22.451H9.194ZM8.77,20.227l.036,1.466H6.093v-.539a.379.379,0,0,0-.123-.279,9.441,9.441,0,0,1-2.941-5.463l-.267-1.688a.341.341,0,0,1,.071-.281.23.23,0,0,1,.2-.082.417.417,0,0,1,.364.345l.172.871a7.328,7.328,0,0,0,3.245,4.761.379.379,0,0,0,.54-.492l-.736-1.455L6.371,16.31a.208.208,0,0,1,.033-.181.136.136,0,0,1,.109-.045.253.253,0,0,1,.2.146L7.3,17.39a.379.379,0,0,0,.1.124,3.743,3.743,0,0,1,1.37,2.714Zm8.73-4.593H8.057a.758.758,0,1,1,0-1.515H17.5a1.818,1.818,0,0,0,0,1.515Zm3.811,8.332H17.525V22.451h3.787ZM20,16.229a.253.253,0,0,1,.2-.146.123.123,0,0,1,.108.045.208.208,0,0,1,.033.181L20.1,17.392l-.735,1.457a.379.379,0,0,0,.54.492A7.328,7.328,0,0,0,23.15,14.58l.172-.871a.417.417,0,0,1,.363-.348.242.242,0,0,1,.2.082.341.341,0,0,1,.071.281l-.267,1.688a9.441,9.441,0,0,1-2.941,5.463.379.379,0,0,0-.123.279v.54H17.913l.036-1.466a3.743,3.743,0,0,1,1.371-2.714.372.372,0,0,0,.1-.124ZM19.419,4.651V14.5a1.134,1.134,0,0,1-1,1.123,1.032,1.032,0,0,1,.094-1.577.379.379,0,0,0-.227-.682H10.33V3.894a1.136,1.136,0,0,1,1.136-1.136h8.752a2.641,2.641,0,0,0-.8,1.894Zm.8-.379a1.894,1.894,0,0,1,3.711,0Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24320",
    "data-name": "Path 24320",
    d: "M33.059,18H32.3v3.787h-.757v-3.03h-.757v3.03H30.03V19.515h-.757v2.272h-.757V20.272h-.757v1.515H27v.757h6.817v-.757H33.06Z",
    transform: "translate(-15.534 -9.941)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24321",
    "data-name": "Path 24321",
    d: "M30.26,11.977l.878.585a.379.379,0,0,0,.5-.069L33.91,9.842l-.575-.492-2.054,2.4-.857-.571a.379.379,0,0,0-.478.047l-2.651,2.651.536.536Z",
    transform: "translate(-15.716 -4.566)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.7d607b7753a73d17b73cbef5f2ab5afd.svg";
export { ForwardRef as ReactComponent };